export default class QrCodeHelper {
  static makeQueryQrCode(qrHref) {
    const qrCodeParams = "https://api.dub.co/qr?size=500&url=";
    const referrer = "?referrer=QR+Code";
    const concatenated = qrHref.concat(referrer);
    const encodedQuery = encodeURIComponent(concatenated);
    const realQuery = qrCodeParams.concat(encodedQuery);
    return realQuery;
  }
}
